// eslint-disable-next-line import/no-anonymous-default-export
export default {
  coeMyWork: {
    entityTypeName: "I initiated",
    name: "Work Order Name",
    introduction: "Initiate and manage my automation requirements",
  },
};
